import { useTranslation } from 'react-i18next';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { GREEN, WHITE } from '@social-garden/utils/colors.ts';

export default function RootLayoutSuspenseFallback() {
  const { t } = useTranslation(['manager']);
  return (
    <Stack
      sx={{
        background: (theme) =>
          theme.palette.mode === 'light' ? GREEN['600'] : GREEN['900'],
        color: WHITE,
      }}
      flex={1}
      p={4}
      alignItems="center"
      justifyContent="center"
      textAlign="center">
      <Typography variant="h2" align="center">
        {t('root.suspenseFallback.appLoading')}
      </Typography>
      <Stack
        position="absolute"
        bottom={0}
        left={0}
        right={0}
        alignItems="center"
        justifyContent="center"
        p={4}>
        <CircularProgress color="inherit" />
      </Stack>
    </Stack>
  );
}
